// state
export const state = {
  fee: {
    configData: null
  },
  newsHeight: null,
  news: {
    height: null,
    edited: false
  },
  rules: {
    height: null
  },
  message: {
    height: null,
    edited: false
  },
  systemUpdates: {
    height: null
  },
  communityGas: {
    height: null,
    edited: false
  },
  guest: {
    height: null,
    edited: false
  },
  vote: {
    height: null,
    edited: false
  },
  evCharging: {
    // 開啟充電樁戶別時，去記住開啟的ConnectorSn
    privateChargingConnectorSn: '',
    isOpenPrivateChargingAuthorizedDialog: false
  },
  intercom: {
    // 對講機列表有一個部分銷售的dialog，控制其開關
    isOpenAuthorizedDialog: false
  },
  lang: 'zh-TW',
  // 可直接取此值得到最新的經緯度位置
  position: {
    latitude: 0,
    longitude: 0
  },
  localStorage: {}
}
// mutations
export const mutations = {
  // action 發出 commit 會對應到 mutation 使用的是 Object key 方式
  FeeUpdateConfig (state, data) {
    // 在 mutation 改變 state（只有 mutation 可以改變！）
    state.fee.configData = JSON.parse(JSON.stringify(data))
  },
  // 社區公告
  giveNewsHeight (state, val) {
    state.news.height = val
  },
  ifNewsEdit (state, val) {
    state.news.edited = val
  },
  // 規約辦法
  recordRulesHeight (state, val) {
    state.rules.height = val
  },
  // 意見反映
  giveMessageHeight (state, val) {
    state.message.height = val
  },
  ifMessageReplyEdit (state, val) {
    state.message.edited = val
  },
  // 系統公告
  recordSystemUpdatesHeight (state, val) {
    state.systemUpdates.height = val
  },
  // 瓦斯抄表
  recordCommunityGasHeight (state, val) {
    state.communityGas.height = val
  },
  ifCommunityGasEdit (state, val) {
    state.communityGas.edited = val
  },
  // 訪客登記結合門禁系統
  recordPlusGuestReservationHeight (state, val) {
    state.guest.height = val
  },
  ifGuestArriveEdit (state, val) {
    state.guest.edited = val
  },
  // 社區投票
  giveVoteHeight (state, val) {
    state.vote.height = val
  },
  ifVoteEdit (state, val) {
    state.vote.edited = val
  },
  triggerPrivateChargingConnectorSn (state, val) {
    state.evCharging.privateChargingConnectorSn = val
  },
  triggerPrivateChargingAuthorizedDialog (state, val) {
    state.evCharging.isOpenPrivateChargingAuthorizedDialog = val
  },
  triggerAuthorizedDialog (state, val) {
    state.intercom.isOpenAuthorizedDialog = val
  },
  changeLanguage (state, data) {
    state.lang = data
  },
  setGeolocation (state, data) {
    if (!data) return
    state.position.latitude = data.latitude
    state.position.longitude = data.longitude
  },
  setLocalStorage (state, data) {
    state.localStorage = data
  }
}
